/**
 * @generated SignedSource<<310646087654e8d93fe4ed926e40fb35>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type updateRiskInput = {
  clientMutationId?: string | null;
  description?: string | null;
  id: string;
  summary?: string | null;
};
export type UpdateRiskMutation$variables = {
  input: updateRiskInput;
};
export type UpdateRiskMutation$data = {
  readonly updateRisk: {
    readonly risk: {
      readonly description: string | null;
      readonly id: string;
      readonly lastEditedBy: {
        readonly pii: {
          readonly name: string | null;
          readonly picture: string | null;
        } | null;
      } | null;
      readonly lastEditedDate: string | null;
      readonly summary: string | null;
    } | null;
  } | null;
};
export type UpdateRiskMutation = {
  response: UpdateRiskMutation$data;
  variables: UpdateRiskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "summary"
},
v4 = {
  "kind": "ScalarField",
  "name": "description"
},
v5 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "picture"
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "UpdateRiskMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "updateRiskPayload",
        "kind": "LinkedField",
        "name": "updateRisk",
        "plural": false,
        "selections": [
          {
            "concreteType": "Risk",
            "kind": "LinkedField",
            "name": "risk",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "lastEditedBy",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateRiskMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "updateRiskPayload",
        "kind": "LinkedField",
        "name": "updateRisk",
        "plural": false,
        "selections": [
          {
            "concreteType": "Risk",
            "kind": "LinkedField",
            "name": "risk",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "lastEditedBy",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "2f157cf7ab0d66d85c1dd3ca6069b518",
    "id": null,
    "metadata": {},
    "name": "UpdateRiskMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateRiskMutation(\n  $input: updateRiskInput!\n) {\n  updateRisk(input: $input) {\n    risk {\n      id\n      summary\n      description\n      lastEditedBy {\n        pii {\n          name\n          picture\n        }\n        id\n      }\n      lastEditedDate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9d703f087477887300613deb90cd14f";

export default node;
